import React from 'react'
import { APP_PREFIX_PATH } from 'constants/route.constant'
import { ADMIN} from 'constants/roles.constant'

const appsRoute = [
    {
        key: 'accessdenied',
        path: `${APP_PREFIX_PATH}/crm/auth/AccessDenied`,
        path: "/access-denied",
        component: React.lazy(() => import('views/auth/AccessDenied')),
    },
    //    {
    //     key: 'home',
    //     path: `${APP_PREFIX_PATH}/crm/auth/AccessDenied`,
    //     path: "/access-denied",
    //     component: React.lazy(() => import('views/auth/AccessDenied')),
    // },

]

export default appsRoute